import { useLanguage } from "../context/LanguageContext";
import { Mail } from "lucide-react";

const EMAIL = "contact@sahalab.com";

const Contact = () => {
  const { t } = useLanguage();

  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="relative py-24 md:py-32"
    >
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="grid lg:grid-cols-2 gap-14 lg:gap-20 items-start">
          <div>
            <div className="text-xs uppercase tracking-[0.25em] text-[var(--brand-gold)] mb-4">
              {t.contact.eyebrow}
            </div>
            <h2 className="font-display text-[42px] md:text-[64px] leading-[1.05] text-[var(--text-primary)] mb-6">
              {t.contact.title}
            </h2>
            <p className="text-base md:text-lg text-[var(--text-secondary)] leading-relaxed max-w-md">
              {t.contact.subtitle}
            </p>
          </div>

          <div
            data-testid="contact-card"
            className="bg-[var(--bg-subtle)] rounded-[32px] p-8 md:p-12"
          >
            <div className="flex items-center gap-3 mb-5">
              <span className="inline-flex items-center justify-center w-10 h-10 shrink-0 rounded-2xl bg-white border border-[var(--brand-gold)]/30">
                <Mail className="w-4 h-4 text-[var(--brand-gold)]" strokeWidth={1.5} />
              </span>
              <div className="text-xs uppercase tracking-[0.25em] text-[var(--brand-gold)]">
                {t.contact.email_label}
              </div>
            </div>
            <a
              href={`mailto:${EMAIL}`}
              data-testid="contact-email-link"
              className="block font-display text-2xl sm:text-3xl md:text-[40px] leading-tight text-[var(--text-primary)] hover:text-[var(--brand-gold)] break-words"
            >
              {EMAIL}
            </a>
            <p className="mt-6 text-sm text-[var(--text-secondary)] leading-relaxed">
              {t.contact.reply_note}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
